import StatsPanel from "../components/StatsPanel";

export default function StatsPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <StatsPanel />
    </div>
  );
}